// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"264":"903daf38","524":"278adfb5","546":"da051fae","717":"62360bc0"}[chunkId] + ".chunk.js";
};